// extracted by mini-css-extract-plugin
module.exports = {"cWhite":"#FFFFFF","cTradewind":"#6BBCB4","UserLives":"UserLives_UserLives__B1xg_"};